import { TerminalVersionDtoToEntity } from "src/app/features/TerminalVersion/services/mappers/TerminalVersionDtoToEntity";
import type { TerminalVersionDto } from "src/app/features/TerminalVersion/types/TerminalVersionDto";
import type { TerminalVersionEntity } from "src/app/features/TerminalVersion/types/TerminalVersionEntity";
import type { ResourcePageDto } from "../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../core/types/fe/entities/ResourcePageEntity";

export const TerminalVersionTableDtoMapper = (
    input: Readonly<ResourcePageDto<TerminalVersionDto>>,
): ResourcePageEntity<TerminalVersionEntity> => {
    return {
        list: input.list ? input.list.map(TerminalVersionDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
